import Vue from 'vue';
import CustomModal from './Modal.vue';

const modal = Vue.extend(CustomModal);
let instance = new modal({}).$mount();
document.body.appendChild(instance.$el);
CustomModal.confirm = function (option) {
    //这个要合并的type属性是根据调用方法来确定类型的，对应modal.vue中要设置的type,这个地方是必填项，后面扩展的话自己考虑，类似于iview中success、error、warming等类型，用来区分
    Object.assign(instance, option,{type:'confirm'});
    instance.show = true;
}
CustomModal.info = function (option) {
    Object.assign(instance, option,{type:'info'});
    instance.show = true;
}
export default CustomModal;
